import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

export default class CreditNoteTable extends Component {
  render(){
    return (
      <table className="table table-striped table-bordered datatable mb-0">
        <thead>
          <tr>
            <th>Id</th>
            <th>Invoice number</th>
            <th>Credit Note Number</th>
            <th className="hidden-xs-down">Vendor</th>
            <th className="hidden-xs-down">Date Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <CreditNoteList creditNotes={this.props.list}/>
      </table>
    )
  }
};

const CreditNoteTableRow = (props) => {
    let date = props.creditNote ? moment(props.creditNote.created_at).format('L') : '';
    return(
      <tr>
        <td>{props.creditNote ? props.creditNote.id : ''}</td>
        <td>
          <NavLink to={`/invoice/${props.creditNote.invoice_data.id}`}>
            {props.creditNote.invoice_data.invoice_number}
          </NavLink>
        </td>
        <td>{props.creditNote.credit_note_number || '-'}</td>
        <td className="hidden-xs-down">{props.creditNote.invoice_data.vendor.name}</td>
        <td className="hidden-xs-down">{date}</td>
        <td>
          <NavLink to={`/credit_note/${props.creditNote.id}`} className="btn-sm btn-info">
            <i className="fa fa-eye"></i>
          </NavLink>
        </td>
      </tr>
    )
};

const CreditNoteList = (props) => {
  return (
    <tbody>
      {props.creditNotes.map((c,idx) => {
          return <CreditNoteTableRow creditNote={c} key={idx}/>
        })
      }
    </tbody>
  );
};
